import { Box } from '@mui/system';

import NumberSteps from '../NumberSteps';
import AddProductStepOne from './dependencies/AddProductStepOne';
import AddProductStepThree from './dependencies/AddProductStepThree';
import AddProductStepTwo from './dependencies/AddProductStepTwo';
import useAddProduct from './useAddProduct';

interface AddProductProps {
  onClose?: () => void;
  onProductsAdded?: () => Promise<void>;
}

const AddProduct = ({ onClose, onProductsAdded }: AddProductProps) => {
  const hook = useAddProduct({ onClose, onProductsAdded });

  return (
    <Box sx={{ width: '100%' }}>
      <NumberSteps
        step={hook.currentStep}
        titles={['Agregar fotos de productos', 'Descargar plantilla para tu catálogo', 'Subir CSV']}
      />
      {hook.currentStep === 1 && (
        <AddProductStepOne
          step={hook.currentStep}
          setCurrentStep={hook.handleChangeStep}
          setUrlTemplate={hook.handleChangeUrlTemplate}
          getTemplate={hook.getTemplate}
          register={hook.register}
          errors={hook.errors}
          images={hook.images}
          setImages={hook.setImages}
        />
      )}
      {hook.currentStep === 2 && (
        <AddProductStepTwo
          step={hook.currentStep}
          setCurrentStep={hook.handleChangeStep}
          urlTemplate={hook.urlTemplate}
          isPendingTemplate={hook.isPendingTemplate}
        />
      )}
      {hook.currentStep === 3 && (
        <AddProductStepThree
          step={hook.currentStep}
          setCurrentStep={hook.handleChangeStep}
          importProducts={hook.importProducts}
          isPendingImport={hook.isPendingImport}
        />
      )}
    </Box>
  );
};

export default AddProduct;
